import { folderStore } from '../store/store';
import type { MailFolder } from 'owa-graph-schema';
import isFolderOrSubFolderOfDistinguishedFolder, {
    FolderTableState,
    isUnderDistinguishedFolder,
} from './isFolderOrSubFolderOfDistinguishedFolder';

export default function isFolderUnderMsg(
    folder: MailFolder,
    state: FolderTableState = { folderTable: folderStore.folderTable }
): boolean {
    return isUnderDistinguishedFolder(folder, 'msgfolderroot', state);
}

/**
 * @param folderId - Id of folder for which we are checking
 * @returns boolean - true if folder is primary root or a subfolder of primary root
 */
export function isFolderOrSubFolderOfMsgRoot(folderId: string): boolean {
    return isFolderOrSubFolderOfDistinguishedFolder(
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (24,9): Argument of type 'MailFolder | undefined' is not assignable to parameter of type 'MailFolder'.
        // @ts-expect-error
        folderStore.folderTable.get(folderId),
        'msgfolderroot'
    );
}
